//@ts-nocheck
import * as PropTypes from 'prop-types';
import './PassengerFieldsSecondRound.css';
import { Box, Skeleton } from '@mui/material';

const SecondRounFormSkeleton = ({ id }) => {
  return (
    <Box
      id={id}
      data-testid='passenger-fields-skeleton'
      className='passenger-fields-second-round-page__container'
    >
      <Box className='passenger-fields-second-round-page__content'>
        {/* Header Skeleton */}
        <Box className='passenger-fields-second-round-page__header'>
          <Box>
            <Skeleton variant='rectangular' width={120} height={40} />
          </Box>
          <Box className='passenger-fields-second-round-page__header-title'>
            <Skeleton variant='text' width={300} height={32} />
            <Skeleton variant='text' width={200} height={20} />
          </Box>
        </Box>

        {/* Form Title Skeleton */}
        <Box className='passenger-fields-second-round-page__form-title'>
          <Box className='passenger-fields-form-title'>
            <Skeleton variant='circular' width={32} height={32} />
            <Skeleton variant='text' width={180} height={24} />
          </Box>
        </Box>

        {/* System Fields Skeleton */}
        <Box className='passenger-fields-second-round-page__form-mandatory'>
          <Box className='w-100 flex-left gap-12'>
            <Box className='w-50 passenger-form__input-container'>
              <Skeleton variant='text' width={100} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} />
            </Box>
            <Box className='w-50 passenger-form__input-container'>
              <Skeleton variant='text' width={100} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} />
            </Box>
          </Box>
          <Box className='w-100 flex-left gap-12'>
            <Box className='w-100 passenger-form__input-container'>
              <Skeleton variant='text' width={120} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} />
            </Box>
          </Box>
        </Box>

        {/* Dynamic Form Fields Skeleton */}
        <Box className='passenger-fields-second-round-page__form-current'>
          {[1, 2, 3].map((item) => (
            <Box key={item} className='w-100 passenger-form__input-container'>
              <Skeleton variant='text' width={150} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} />
            </Box>
          ))}
        </Box>

        {/* Submit Button Skeleton */}
        <Box className='passenger-fields-second-round-page__footer'>
          <Skeleton
            variant='rectangular'
            width='100%'
            height={48}
            sx={{ borderRadius: 1 }}
          />
        </Box>
      </Box>
    </Box>
  );
};

SecondRounFormSkeleton.propTypes = {
  id: PropTypes.string.isRequired
};

export default SecondRounFormSkeleton;
